import React, { useState, useEffect } from 'react';
import './RadiologyAmendmentModal.css';

const RadiologyAmendmentModal = ({ isOpen, onClose, currentVersion = 1, onConfirmAmendment }) => {
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) {
      setReason('');
      setError('');
      setIsSubmitting(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim() || reason.trim().length < 5) {
      setError('Please provide a detailed clinical reason for this amendment (minimum 5 characters).');
      return;
    }

    setIsSubmitting(true);
    setError('');
    try {
      await onConfirmAmendment(reason.trim());
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to initiate report amendment.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="rad-modal-backdrop">
      <div className="rad-amend-modal">
        <div className="rad-amend-header">
          <div className="rad-amend-title-group">
            <span className="rad-amend-icon">📝</span>
            <div>
              <h3>Request Formal Report Amendment</h3>
              <p className="rad-amend-subtitle">Controlled medical record revision with complete audit traceability</p>
            </div>
          </div>
          <button className="rad-amend-close" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit} className="rad-amend-body">
          <div className="rad-amend-notice">
            <strong>⚠️ Controlled Clinical Workflow:</strong>
            <p>
              This report has already been signed off as <strong>Version {currentVersion}</strong>.
              Creating an amendment will establish <strong>Version {currentVersion + 1}</strong>.
              The prior signed version will remain permanently archived and accessible in the audit trail.
            </p>
          </div>

          {error && (
            <div className="rad-amend-error">
              <span>⚠️</span> {error}
            </div>
          )}

          <div className="rad-amend-field">
            <label className="rad-label">
              Clinical Amendment Reason * <span className="req">(Mandatory)</span>
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="E.g., Correction to right renal calculus measurement from 6 mm to 7.5 mm following secondary slice reconstruction."
              rows={4}
              className="rad-textarea"
              required
            />
          </div>

          <div className="rad-amend-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="btn-danger"
              disabled={isSubmitting || !reason.trim()}
            >
              {isSubmitting ? 'Creating Amendment...' : `Confirm & Amend to Version ${currentVersion + 1}`}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RadiologyAmendmentModal;
